// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState } from "react";

export default function CenterPage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const line = localStorage.getItem("line");
  const changeline = (linenum) => {
    localStorage.setItem("line", linenum);
    navigate(-1);
  };

  return (
    <div className="min-h-screen p-4 md:p-6">
      <div className="max-w-md mx-auto space-y-3">
        <div
          className={`${
            line == 1
              ? "bg-primary/20 border-primary/50 shadow-[0_0_15px_rgba(139,92,246,0.3)]"
              : "bg-neutral-800/50 border-neutral-700/30 hover:bg-neutral-700/70"
          } cursor-pointer rounded-xl p-4 border backdrop-blur-sm text-white font-medium transition-all duration-300 ease-out hover:scale-[1.02] hover:shadow-lg flex justify-between items-center`}
          onClick={() => {
            changeline(1);
          }}
        >
          <span>{translate(getText("線路"))} 1</span>
          <span className="text-primary-light text-sm">[926ms]</span>
        </div>
        <div
          className={`${
            line == 2
              ? "bg-primary/20 border-primary/50 shadow-[0_0_15px_rgba(139,92,246,0.3)]"
              : "bg-neutral-800/50 border-neutral-700/30 hover:bg-neutral-700/70"
          } cursor-pointer rounded-xl p-4 border backdrop-blur-sm text-white font-medium transition-all duration-300 ease-out hover:scale-[1.02] hover:shadow-lg flex justify-between items-center`}
          onClick={() => {
            changeline(2);
          }}
        >
          <span>{translate(getText("線路"))} 2</span>
          <span className="text-primary-light text-sm">[-ms]</span>
        </div>
      </div>
    </div>
  );
}
